(() => {
  'use strict';
  if (window.MenkraftersQuoteInstalled) return;
  window.MenkraftersQuoteInstalled = true;

  function initialize(root) {
    if (root.dataset.mkqInitialized) return;
    root.dataset.mkqInitialized = 'true';
    root.classList.add('mkq-enhanced');
    const rows = Array.from(root.querySelectorAll('.mkq-service'));
    const groups = Array.from(root.querySelectorAll('[data-group]'));
    const filters = Array.from(root.querySelectorAll('[data-filter]'));
    const search = root.querySelector('[data-search]');
    const resultCount = root.querySelector('[data-result-count]');
    const noResults = root.querySelector('[data-no-results]');
    const checks = Array.from(root.querySelectorAll('.mkq-service-check'));
    const primary = root.querySelector('[data-primary]');
    const selectedList = root.querySelector('[data-selected]');
    const emptySelection = root.querySelector('[data-selection-empty]');
    const form = root.querySelector('.mkq-form');
    const panels = Array.from(root.querySelectorAll('[data-project-panel]'));
    const countDisplays = Array.from(root.querySelectorAll('[data-selection-count]'));
    let activeFilter = 'all';

    const normalize = value => String(value || '').toLocaleLowerCase().trim();
    const selectedChecks = () => checks.filter(check => check.checked);

    function applyFilter() {
      const term = normalize(search ? search.value : '');
      let visible = 0;
      rows.forEach(row => {
        const matchesCategory = activeFilter === 'all' || row.dataset.category === activeFilter;
        row.hidden = !(matchesCategory && normalize(row.textContent).includes(term));
        if (!row.hidden) visible += 1;
      });
      groups.forEach(group => {
        group.hidden = !rows.some(row => row.dataset.category === group.dataset.group && !row.hidden);
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === activeFilter)));
      if (resultCount) resultCount.textContent = `${visible} ${visible === 1 ? 'service' : 'services'}`;
      if (noResults) noResults.hidden = visible !== 0;
    }

    function setFilter(category) {
      activeFilter = filters.some(button => button.dataset.filter === category) ? category : 'all';
      applyFilter();
    }

    function updatePanels() {
      if (!primary) return;
      const selectedOption = primary.options[primary.selectedIndex];
      const category = selectedOption ? selectedOption.dataset.category : '';
      const categories = new Set(selectedChecks().map(check => check.dataset.category));
      if (category && category !== 'other') categories.add(category);
      panels.forEach(panel => {
        const visible = category === 'other' || categories.has(panel.dataset.projectPanel);
        panel.hidden = !visible;
        panel.querySelectorAll('input, select, textarea').forEach(control => { control.disabled = !visible; });
      });
    }

    function updateSelection() {
      const chosen = selectedChecks();
      countDisplays.forEach(node => { node.textContent = String(chosen.length); });
      if (selectedList) {
        selectedList.replaceChildren();
        chosen.forEach(check => {
          const item = document.createElement('li');
          const name = document.createElement('span');
          name.textContent = check.value;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeService = check.dataset.serviceId;
          remove.textContent = '×';
          remove.setAttribute('aria-label', `Remove ${check.value}`);
          item.append(name, remove);
          selectedList.append(item);
        });
      }
      if (emptySelection) emptySelection.hidden = chosen.length > 0;
      checks.forEach(check => {
        const row = check.closest('.mkq-service');
        if (row) {
          row.classList.toggle('mkq-is-selected', check.checked);
          const label = row.querySelector('[data-pick-label]');
          if (label) label.textContent = check.checked ? 'Added' : 'Add';
        }
      });
      updatePanels();
    }

    function handleCheck(check) {
      if (primary) {
        if (check.checked && !primary.value) primary.value = check.value;
        if (!check.checked && primary.value === check.value) {
          const next = selectedChecks()[0];
          primary.value = next ? next.value : '';
        }
      }
      updateSelection();
    }

    filters.forEach(button => button.addEventListener('click', () => setFilter(button.dataset.filter)));
    if (search) search.addEventListener('input', applyFilter);
    root.querySelectorAll('[data-jump-category]').forEach(link => {
      link.addEventListener('click', () => {
        if (search) search.value = '';
        setFilter(link.dataset.jumpCategory);
      });
    });
    checks.forEach(check => check.addEventListener('change', () => handleCheck(check)));
    if (primary) primary.addEventListener('change', () => {
      const matching = checks.find(check => check.value === primary.value);
      if (matching) matching.checked = true;
      updateSelection();
    });
    if (selectedList) selectedList.addEventListener('click', event => {
      const button = event.target.closest('[data-remove-service]');
      if (!button) return;
      const check = checks.find(item => item.dataset.serviceId === button.dataset.removeService);
      if (!check) return;
      check.checked = false;
      handleCheck(check);
      // Keep keyboard focus in the selection area after removing a focused chip.
      const remainingButton = selectedList.querySelector('button');
      if (remainingButton) remainingButton.focus();
      else if (primary) primary.focus();
    });

    if (form) {
      const phone = form.querySelector('[data-phone]');
      const reply = form.querySelector('[data-reply]');
      function syncPhoneRequirement() {
        if (phone) phone.required = Boolean(reply && ['Phone call', 'Text message'].includes(reply.value));
      }
      if (reply) reply.addEventListener('change', syncPhoneRequirement);
      syncPhoneRequirement();
      form.addEventListener('submit', event => {
        syncPhoneRequirement();
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }
        // The standalone preview never sends customer data or fakes success.
        // On Shopify, native contact-form submission and spam protection run.
        if (form.hasAttribute('data-preview-form')) {
          event.preventDefault();
          const feedback = root.querySelector('[data-preview-feedback]');
          if (feedback) {
            feedback.hidden = false;
            feedback.textContent = 'Preview only: your sample request was not sent. After this page is installed in Shopify, the form submits the request to your store’s sender email.';
            feedback.focus();
          }
        }
      });
    }
    const feedback = root.querySelector('[data-feedback]');
    if (feedback) feedback.focus();
    applyFilter();
    updateSelection();
  }

  function mount(container) {
    if (container.matches && container.matches('[data-mkq-page]')) initialize(container);
    container.querySelectorAll('[data-mkq-page]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  window.addEventListener('pageshow', () => {
    // Restore checked-state presentation when the browser returns from a post.
    document.querySelectorAll('[data-mkq-page]').forEach(root => {
      const check = root.querySelector('.mkq-service-check');
      if (check) check.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();
